/**
 * Youtube用のutilクラス
 */
class YoutubeUtil {
  /**
   * 通常のURLを埋め込み形式URLとして変換する
   * すでに埋め込み形式だった場合か、通常のURL以外の場合、何もせずに返す
   */
  static getEmbedUrl (url) {
    if (!url) return
    let index = url.indexOf('watch?v=')
    if (index < 0) return url
    let param = url.substring(index + 8)
    index = param.indexOf('&')
    if (index >= 0) {
      param = param.substring(0, index)
    }
    return 'https://www.youtube.com/embed/' + param
  }
}

export default YoutubeUtil
